import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const TrialBanner = () => {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  useEffect(() => {
    if (user?.role === "superadmin") return;
    api.get("/billing/subscription").then(({ data }) => setS(data)).catch(() => {});
  }, [user?.role]);
  if (user?.role === "superadmin") return null;
  if (!s) return null;
  const sub = s.subscription || {};
  if (sub.status === "active" || sub.status === "free" || s.free_account) return null;
  const trialing = sub.status === "trialing";
  const bad = ["past_due", "suspended", "cancelled"].includes(sub.status);
  if (!trialing && !bad) return null;
  return (
    <div data-testid="trial-banner"
      className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border px-4 py-2.5 text-sm ${bad ? "border-destructive/40 bg-destructive/5 text-destructive" : "border-primary/30 bg-primary/5 text-foreground"}`}>
      <span className="flex items-center gap-2">
        {bad ? <AlertTriangle className="h-4 w-4" /> : <Sparkles className="h-4 w-4 text-primary" />}
        {trialing
          ? `You're on a free trial — ${s.trial_days_left ?? 0} day${s.trial_days_left === 1 ? "" : "s"} left.`
          : `Your subscription is ${sub.status}. Reactivate to keep your team's seats.`}
      </span>
      {user?.role === "admin" ? (
        <Link to="/app/billing" data-testid="trial-banner-cta"
          className="rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground transition-opacity hover:opacity-90">Choose a plan</Link>
      ) : (
        <span className="text-xs text-muted-foreground">Ask your agency admin to choose a plan.</span>
      )}
    </div>
  );
};
